import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import { useTranslation } from '../../contexts/translation-context';
import React, { useCallback, useEffect, useRef } from 'react';
import { getNumberOfDecimals, isNumberInputValid, isNumberInputPossible, normalizeDecimalSeparator } from '../../ui/shared/numeric-input-utils';
import { useFocus } from '../../hooks/use-focus';
import { TextField as TPATextField, TextFieldTheme } from 'wix-ui-tpa/cssVars';
import classNames from 'classnames';
import { classes } from '../../ui/number-input-field/number-input-field-wut.st.css';
import { useInvokeCallback } from '../../ui/shared/use-invoke-callback';
import { useFocusFieldEvent } from '../../contexts/events-context';
export const NumberInputWUT = _ref => {
  var _validation$number, _validation$number2, _validation$number3;
  let {
    value,
    validation,
    required,
    label,
    disabled,
    readOnly,
    placeholder,
    onChange,
    onBlur,
    onFocus,
    hasError,
    inputId,
    ariaDescribedBy,
    fieldId
  } = _ref;
  const {
    t
  } = useTranslation();
  const multipleOf = (validation == null || (_validation$number = validation.number) == null ? void 0 : _validation$number.multipleOf) || 1;
  const maximum = validation == null || (_validation$number2 = validation.number) == null ? void 0 : _validation$number2.maximum;
  const minimum = validation == null || (_validation$number3 = validation.number) == null ? void 0 : _validation$number3.minimum;
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const _value = String(value ?? '');
  const [inputValue, setInputValue] = React.useState(_value);
  const invokeBlur = useInvokeCallback(onBlur);
  const inputRef = useRef(null);
  useFocusFieldEvent(() => {
    var _inputRef$current;
    (_inputRef$current = inputRef.current) == null || _inputRef$current.focus();
  }, fieldId);
  const numberOnChange = useCallback(event => {
    const newValue = normalizeDecimalSeparator(event.target.value);
    const isValid = isNumberInputPossible(newValue, multipleOf);
    if (isValid) {
      setInputValue(newValue);
    }
  }, [multipleOf]);
  const handleBlur = useCallback(() => {
    const newValue = Number(inputValue);
    if (inputValue === '' || Number.isNaN(newValue)) {
      onChange('');
      invokeBlur();
      return;
    }
    const numberOfDecimals = getNumberOfDecimals(multipleOf);
    const validValue = isNumberInputValid(newValue, multipleOf) ? newValue : newValue.toFixed(numberOfDecimals);
    onChange(Number(validValue));
    setInputValue(String(validValue));
    invokeBlur();
  }, [inputValue, multipleOf, onChange, invokeBlur]);
  useEffect(() => {
    setInputValue(_value);
  }, [_value]);
  const {
    handleFocus,
    containerRef
  } = useFocus({
    onFocus
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    onFocus: handleFocus,
    onBlur: handleBlur
  }, /*#__PURE__*/React.createElement(TPATextField, {
    id: inputId,
    type: "text",
    inputMode: multipleOf ? 'decimal' : 'numeric',
    error: hasError,
    newErrorMessage: true,
    value: inputValue,
    className: classNames(classes.textField, classes.theme, {
      [classes.error]: hasError,
      [classes.hover]: forcedHover
    }),
    onChange: numberOnChange,
    disabled: disabled,
    readOnly: readOnly,
    placeholder: placeholder,
    min: minimum ?? undefined,
    max: maximum ?? undefined,
    "aria-label": label,
    "aria-roledescription": t('field.number.aria-role-description'),
    theme: TextFieldTheme.Box,
    "aria-describedby": ariaDescribedBy,
    "aria-invalid": hasError,
    required: required,
    ref: inputRef
  }));
};
//# sourceMappingURL=number-input-wut.js.map